import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useUserRole } from "./useUserRole";

/**
 * Hook that provides role-based dashboard navigation.
 * Returns the appropriate dashboard path and a function to navigate there.
 */
export function useDashboardNavigation() {
  const navigate = useNavigate();
  const { loading, isAdmin, isRep, isAuditor } = useUserRole();

  const getDashboardPath = useCallback((): string | null => {
    if (isAdmin) return "/manage";
    if (isRep) return "/proofing";
    if (isAuditor) return "/audit";
    return null;
  }, [isAdmin, isRep, isAuditor]);

  const navigateToDashboard = useCallback(() => {
    const path = getDashboardPath();
    if (path) {
      navigate(path);
    }
  }, [getDashboardPath, navigate]);

  return {
    loading,
    getDashboardPath,
    navigateToDashboard,
  };
}
